import React, { useEffect, useRef, useState } from "react";

import { useDispatch } from "react-redux";
import { setselectedTab } from "../../../Store/B2bslice";
import { Button, Form, Modal, Select } from "antd";
import CommonInput from "../../../Common/CommonInput";
import { getLocalStorageItem, mobilePattern } from "../../../Utils";
import {
  bbps2BillPayment,
  bbps2getOperator,
  getBbps2Services,
} from "./Recharge2Endpoint";
const Bbps2 = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [operatorList, setOperatorList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [value, setvalue] = useState({});
  const [pinpopup, setPinpopup] = useState(false);
  const [trigger, settrigger] = useState(false);

  const [pin, setPin] = useState("");
  const [selectedService, setSelectedService] = useState(0);
  const [btnLoading, setBtnLoading] = useState(false);

  const otpLength = 4;
  const inputRefs = Array.from({ length: otpLength }, () => useRef(null));

  const handleKeyUp = (index, event) => {
    if (event.keyCode === 8) {
      // Clear the previous input field on Backspace if the current field is empty
      if (index > 0 && pin[index] === "") {
        setPin((prevOTP) => {
          const updatedOTP = [...prevOTP];
          updatedOTP.splice(index, 1);
          return updatedOTP;
        });

        // Move focus back to the previous input field
        inputRefs[index - 1].current.focus();
      }
    }
  };

  const handlePinChange = (index, value) => {
    if (/^[0-9]*$/.test(value)) {
      setPin((prevOTP) => {
        const updatedOTP = [...prevOTP];
        updatedOTP[index] = value;
        return updatedOTP;
      });

      // Move to the next input field if the value is numeric
      if (value !== "" && index < otpLength - 1) {
        inputRefs[index + 1].current.focus();
      }
    }
  };




  const getServices = () => {
    getBbps2Services()
      .then((res) => {
        if (res.status) {
          setServiceList(res.data);
        }
      })
      .catch((err) => console.log(err));
  };
  const getOpeartors = () => {
    bbps2getOperator({
      service_key: serviceList[selectedService]?.key,
      operator_type: serviceList[selectedService]?.operator_type,
    })
      .then((res) => {
        if (res.status) {
          setOperatorList(
            res.data?.operators.map((i) => {
              return {
                label: <p>{i?.operator_name}</p>,
                value: i?.operator_code,
                key: i?.operator_type,
              };
            })
          );
        }
      })
      .catch((err) => console.log(err));
  };

  const handlePaybill = (val) => {
    setBtnLoading(true);
    let temp = { ...val };
    temp["opcode"] = val.opcode.value;
    temp["service_type"] = serviceList[selectedService]?.key;
    temp["latitude"] = getLocalStorageItem("latitude");
    temp["longitude"] = getLocalStorageItem("longitude");
    temp["pin"] = pin.join("");
    {
      pin.join() &&

        bbps2BillPayment(temp)
          .then((res) => {
            if (res.status) {
              form.resetFields();
            }
          })
          .catch((err) => console.log(err))
          .finally(() => setBtnLoading(false));
    }


  };
  useEffect(() => {
    getServices();
  }, []);
  useEffect(() => {
    if (serviceList.length > 0) {
      getOpeartors();
    }
  }, [selectedService, serviceList]);
  useEffect(() => {
    dispatch(setselectedTab("202"));
  }, []);

  useEffect(() => {
    if (value && trigger) {
      handlePaybill(value)
    }

  }, [trigger]);


  return (
    <>
      <div className="flex justify-start items-center gap-2 bg-white p-4 rounded-xl">
        {serviceList.map((i, index) => {
          return (
            <p
              onClick={() => setSelectedService(index)}
              className={`font-semibold cursor-pointer ${selectedService === index ? "underline underline-offset-4" : ""
                }`}
            >
              {i?.service_name}
            </p>
          );
        })}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 w place-items-start gap-3 mt-2">
        <div className="w-full h-full bg-white rounded-xl p-3">
          <p className="font-bold">Recharge 2</p>
          <div className="">
            <Form
              form={form}
              onFinish={(val) => { setPinpopup(true); setvalue(val) }}
              labelCol={{ span: 24 }}
            >
              <Form.Item
                rules={[{ required: true, message: "Operator is required" }]}
                name={"opcode"}
                label="Select Operator"
              >
                <Select
                  labelInValue
                  onChange={(val) => console.log(val)}
                  options={operatorList}
                  placeholder="Select Opeartor"
                />
              </Form.Item>
              <Form.Item
                name={"number"}
                rules={[
                  { required: true, message: "Number is required" },
                  {
                    pattern: mobilePattern,
                    message: "Enter valid mobile number",
                  },
                ]}
                label="Mobile Number"
              >
                <CommonInput
                  onInput={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    e.target.value = value;
                  }}
                  placeholder="CommonInput Opeartor"
                />
              </Form.Item>
              <Form.Item
                rules={[{ required: true, message: "Biller Name is required" }]}
                name={"biller_name"}
                label="Biller Name"
              >
                <CommonInput placeholder="Enter biller name" />
              </Form.Item>
              <Form.Item
                rules={[{ required: true, message: "Amount is required" }]}
                name={"amount"}
                label="Amount"
              >
                <CommonInput
                  onInput={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    e.target.value = value;
                  }}
                  placeholder="Enter amount"
                />
              </Form.Item>
              <Form.Item>
                <Button
                  loading={btnLoading}
                  htmlType="submit"
                  className="bg-primary text-white border-none outline-none w-full"
                >
                  Pay bill
                </Button>
              </Form.Item>
            </Form>
          </div>
          {pinpopup &&
            <Modal
              // title={"  Verify Pin"}
              footer={null}
              className="shadow-normal"
              width={300}
              maskClosable={false}
              open={pinpopup}
              onCancel={() => setPinpopup(false)}
            >
              <div>
                {/* <img
              src={Images.WebsiteLogo}
              className="w-1/2"
              style={{ filter: "drop-shadow(0px 1px 2px #cfc5c5)" }}
            /> */}
                <p
                  className="text-start mt-4 font-semibold text-xl"
                  style={{ fontFamily: "system-ui" }}
                >
                  Verify Pin
                </p>
                <div className="  py-10">
                  <div className="w-full mt-2 flex justify-center items-center">
                    {[1, 2, 3, 4].map((i, index) => {
                      return (
                        <input
                          key={index}
                          ref={inputRefs[index]}
                          type="text"
                          maxLength={1}
                          className="w-[25px] xs:w-[35px] sm:w-[40px] md:w-[50px] text-bsblackrgb bg-gray-300 rounded-md h-8  sm:shadow-md s md:shadow-sm mx-1 outline-none border-none text-center"
                          value={pin[index]}
                          onChange={(e) => handlePinChange(index, e.target.value)}
                          onKeyUp={(e) => handleKeyUp(index, e)}
                        />
                      );
                    })}
                  </div>
                  {/* <p onClick={handleSendResetOtp} className="flex justify-end items-center text-primary mt-2 cursor-pointer">Forgot Pin?</p> */}
                  <Button
                    onClick={() => pin.length === 4 && settrigger(true)}
                    className={`SignInBtn w-full ${pin.length === 4 ? "cursor-pointer" : "cursor-not-allowed"
                      }  mt-4 ${pin.length === 4 ? "bg-primary" : "bg-bsgray"
                      }  flex justify-center border-none items-center h-12 rounded-full text-white text-[12px] font-bold`}
                  >
                    <p>Verify PIN</p>
                  </Button>
                </div>

              </div>
            </Modal>
          }
        </div>
      </div>
    </>
  );
};

export default Bbps2;
